export const mobilePayment = {
  mobilePaymentBank: "Bank",
  mobilePaymentPhone: "Foon",
  mobilePaymentAction: "Aksie",
  mobilePaymentEdit: "Wysig",
  mobilePaymentDelete: "Verwyder",
  mobilePaymentDeleteConfirm: "Wil jy regtig die mobiele betaalrekening verwyder?",
  mobilePaymentDeleteYes: "Ja",
  mobilePaymentDeleteNo: "Nee",

  mobilePaymentTitle: "Mobiele betaling",
  mobilePaymentAdd: "Voeg mobiele betaling by",
  mobilePaymentBtnAdd: "Voeg by",
  mobilePaymentBtnBack: "Terug",

  mobilePaymentEditTitle: "Wysig mobiele betaalrekening",

  mobilePaymentModalBank: "Bank",
  mobilePaymentModalPhone: "Foon",
  mobilePaymentModalSelectBank: "Kies bank",
  mobilePaymentModalSelectBankMessage: "Kies asseblief 'n bank",
  mobilePaymentModalPhonePlaceholder: "Foon",
  mobilePaymentModalPhonePlaceholderMessage: "Voer asseblief jou foonnommer in",
  mobilePaymentModalSubmitBtn: "Aanvaar",

  // Nuwe registrasie-modale vertalings
  pagoMovilRegistrationTitle: "Mobiele betaling-registrasie vereis",
  pagoMovilRegistrationMessage:
    "Om deposito's of onttrekkings met Mobiele Betaling te maak, moet jy jou ID en foonnommer registreer.",
  pagoMovilRegistrationCedula: "Identiteitskaart",
  pagoMovilRegistrationCedulaPlaceholder: "Voer jou ID-nommer in",
  pagoMovilRegistrationCedulaMessage: "Voer asseblief jou identiteitskaartnommer in",
  pagoMovilRegistrationCedulaValidation: "Slegs syfers word toegelaat",
  pagoMovilRegistrationCedulaMinLength: "ID-kaart moet ten minste 7 syfers hê",
  pagoMovilRegistrationCedulaMaxLength: "ID-kaart kan nie meer as 15 syfers hê nie",
  pagoMovilRegistrationPhoneNumber: "Foonnommer",
  pagoMovilRegistrationPhoneNumberPlaceholder: "Voer jou foonnommer in",
  pagoMovilRegistrationPhoneNumberMessage: "Voer asseblief jou foonnommer in",
  pagoMovilRegistrationPhoneValidation: "Voer asseblief 'n geldige foonnommer in",
  pagoMovilRegistrationPhoneMinLength: "Foonnommer moet ten minste 10 syfers hê",
  pagoMovilRegistrationSubmitBtn: "Registreer",
  pagoMovilRegistrationCancelBtn: "Kanselleer",
  pagoMovilRegistrationSuccessTitle: "Data suksesvol geregistreer",
  pagoMovilRegistrationSuccessMessage: "Jou ID en foonnommer is suksesvol geregistreer.",
  pagoMovilRegistrationErrorTitle: "Fout met die registrasie van data",
  pagoMovilRegistrationErrorMessage: "Daar was 'n fout met die registrasie van jou inligting. Probeer asseblief weer.",

  // Pago Movil-rekening-opstellingsfout-vertalings
  pagoMovilCreationErrorTitle: "Fout met die byvoeg van rekening",
  pagoMovilCreationErrorMessage: "Kon nie die mobiele betaalrekening byvoeg nie. Probeer asseblief weer.",

  // AddPagoMovil-formuliervertalings
  addPagoMovilExplanationTitle: "Ons het net 'n paar besonderhede nodig",
  addPagoMovilExplanationMessage:
    "Ons benodig hierdie inligting net een keer sodat jou deposito's en onttrekkings glad verloop. Dit is vinnig.",
  registerAndAddPagoMovil: "Registreer en voeg mobiele betaling by",

  // Basiese veldname
  name: "Naam",
  lastName: "Van",
  nationalID: "Nasionale ID",
  phoneNumber: "Foonnommer",
  nameRequired: "Naam word vereis",
  lastNameRequired: "Van word vereis",
  nationalIDRequired: "Nasionale ID word vereis",
  phoneNumberRequired: "Foonnommer word vereis",
  phoneNumberMinLength: "Foonnommer moet ten minste 10 syfers hê",
  phoneNumberMaxLength: "Foonnommer kan nie meer as 11 syfers hê nie",

  // Bevestigingsoorlegging-vertalings
  confirmSaveChanges: "Wil jy regtig die veranderings stoor?",
  accept: "Aanvaar",
  cancel: "Kanselleer",

  // Verwyder-bevestigingsmodale vertalings
  deleteConfirmationTitle: "Verwyder mobiele betaalrekening",
  deleteConfirmationMessage: "Jy is op die punt om een van jou mobiele betaalrekeninge te verwyder",
  deleteConfirmationBank: "Bank",
  deleteConfirmationPhone: "Foon",

  // E-posverifikasie-vertalings
  registrationEmailVerificationTitle: "E-posverifikasie",
  registrationEmailVerificationMessage:
    "'n Verifikasieskakel is na jou e-posadres gestuur. Kontroleer asseblief jou inkassie en klik die skakel om voort te gaan.",
};
